import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';

export default class EudrDashboardService {
    static instance;

    static getInstance() {
        if (!EudrDashboardService.instance) {
            EudrDashboardService.instance = new EudrDashboardService();
        }

        return EudrDashboardService.instance;
    }

    async fetchSummary(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/summary`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            totalSuppliers: 26,
            totalShipments: 48,
            ddsSubmitted: 42,
            totalRelevantProducts: 24,
            totalRelevantLots: 68,
            highRiskSuppliers: 3,
        };
    }

    async fetchGeolocationData(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/geolocation-data`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            supplierId: 7436,
            supplier: 'Barry Callebaut AG',
            country: 'Ghana',
            material: 'Cocoa Beans',
            forestCoverage: '41.8%',
            deforestationRisk: 'high',
            gpsValidation: 'Pending Review',
            lastSatelliteCheck: '2026-07-22',
            geolocation: {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {
                            supplier: 'Barry Callebaut AG',
                            material: 'Cocoa Beans',
                            country: 'Ghana',
                        },
                        geometry: {
                            type: 'Polygon',
                            coordinates: [
                                [
                                    [-1.6325, 6.7125],
                                    [-1.6278, 6.7127],
                                    [-1.6276, 6.7172],
                                    [-1.6322, 6.7175],
                                    [-1.6325, 6.7125],
                                ],
                            ],
                        },
                    },
                ],
            },
        };
    }

    async fetchSupplierStatus(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/supplier-status`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || [];

        await new Promise((resolve) => setTimeout(resolve, 350));

        return [
            {
                label: 'Approved',
                value: 21,
                color: '#1CBB8C',
            },
            {
                label: 'Pending',
                value: 4,
                color: '#5664D2',
            },
            {
                label: 'Rejected',
                value: 1,
                color: '#D9D9D9',
            },
        ];
    }

    async fetchSupplierByRiskLevel(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/supplier-by-risk-level`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || [];

        await new Promise((resolve) => setTimeout(resolve, 350));

        return [
            {
                key: 'very_high',
                label: 'Very High',
                value: 1,
            },
            {
                key: 'high',
                label: 'High',
                value: 2,
            },
            {
                key: 'medium',
                label: 'Medium',
                value: 8,
            },
            {
                key: 'low',
                label: 'Low',
                value: 15,
            },
        ];
    }

    async fetchSubmissionToTrace(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/submission-to-trace`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            chart: [
                {
                    label: 'Submitted',
                    value: 6,
                    color: '#086700',
                },
                {
                    label: 'Verified by TRACE',
                    value: 36,
                    color: '#59c94f',
                },
                {
                    label: 'Missing DDS',
                    value: 6,
                    color: '#c3ff00',
                },
            ],
        
            knob:{
                percentage:75,
            },
        };
    }

    async fetchTradeOperations(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/trade-operations`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            series:[
                {
                    month:'2026-01',
                    totalImport:4,
                    totalExport:2,
                },
                {
                    month:'2026-02',
                    totalImport:4,
                    totalExport:3,
                },
                {
                    month:'2026-03',
                    totalImport:5,
                    totalExport:2,
                },
                {
                    month:'2026-04',
                    totalImport:4,
                    totalExport:3,
                },
                {
                    month:'2026-05',
                    totalImport:5,
                    totalExport:2,
                },
                {
                    month:'2026-06',
                    totalImport:5,
                    totalExport:3,
                },
            ]
        };
    }

    async fetchUpcomingShipmentsMissingDds(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/upcoming-shipments-missing-dds`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || [];

        await new Promise((resolve) => setTimeout(resolve, 350));

        return [
            {
                id:'shp-1',
                shipmentId:'BC-COCOA-1001',
                product:'Cocoa Beans',
                origin:'Côte d’Ivoire',
                destination:'Belgium',
                ddsStatus:'NOT_FOUND',
                date:'2026-08-05',
                priority:'high',
            },
            {
                id:'shp-2',
                shipmentId:'BC-COCOA-1002',
                product:'Cocoa Beans',
                origin:'Ghana',
                destination:'Netherlands',
                ddsStatus:'NOT_FOUND',
                date:'2026-08-12',
                priority:'medium',
            },
            {
                id:'shp-3',
                shipmentId:'BC-COCOA-1003',
                product:'Cocoa Butter',
                origin:'Cameroon',
                destination:'Germany',
                ddsStatus:'NOT_FOUND',
                date:'2026-08-18',
                priority:'high',
            },
            {
                id:'shp-4',
                shipmentId:'BC-COCOA-1004',
                product:'Cocoa Powder',
                origin:'Côte d’Ivoire',
                destination:'France',
                ddsStatus:'NOT_FOUND',
                date:'2026-08-22',
                priority:'high',
            },
            {
                id:'shp-5',
                shipmentId:'BC-COCOA-1005',
                product:'Chocolate Ingredients',
                origin:'Ghana',
                destination:'Italy',
                ddsStatus:'NOT_FOUND',
                date:'2026-08-27',
                priority:'medium',
            },
            {
                id:'shp-6',
                shipmentId:'BC-COCOA-1006',
                product:'Cocoa Beans',
                origin:'Cameroon',
                destination:'Belgium',
                ddsStatus:'NOT_FOUND',
                date:'2026-09-03',
                priority:'high',
            },
        ];
    }

    async fetchRiskHeatmap(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/risk-heatmap`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            allCountries:{
                CI:{
                    color:'DC3545',
                    amount:10
                },
                GH:{
                    color:'DC3545',
                    amount:7
                },
                CM:{
                    color:'FFA049',
                    amount:5
                },
                BR:{
                    color:'1CBB8C',
                    amount:4
                }
            },
        
            rating:[
                {
                    color:'1CBB8C',
                    long_name:'Low'
                },
                {
                    color:'FCC34B',
                    long_name:'Medium'
                },
                {
                    color:'FFA049',
                    long_name:'Noticeable'
                },
                {
                    color:'DC3545',
                    long_name:'High'
                },
                {
                    color:'822626',
                    long_name:'Existence - threatening'
                },
            ]
        };
    }

    async fetchTopDeforestationHotspotRegions(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/top-deforestation-hotspot-regions`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || [];

        await new Promise((resolve) => setTimeout(resolve, 350));

        return [
            {
                id:'region-1',
                region:'Western Côte d’Ivoire Cocoa Belt',
                riskLevel:'high',
                landEvaluated:'4,800 ha',
            },
            {
                id:'region-2',
                region:'Ashanti Cocoa Region, Ghana',
                riskLevel:'medium',
                landEvaluated:'3,600 ha',
            },
            {
                id:'region-3',
                region:'Cameroon Cocoa Basin',
                riskLevel:'medium',
                landEvaluated:'2,100 ha',
            },
            {
                id:'region-4',
                region:'Amazon Cocoa Region, Brazil',
                riskLevel:'low',
                landEvaluated:'1,400 ha',
            },
        ];
    }

    async fetchTopRelevantProductsByRiskLevel(params = {}) {
        // Replace mock implementation with real API call when backend is available.
        // const response = await axios.get(`${API_BASE_URL}/eudr/dashboard/top-relevant-products-by-risk-level`, {
        //     params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
        //     },
        // });
        // return response.data?.data || {};

        await new Promise((resolve) => setTimeout(resolve, 350));

        return {
            products:[
                {
                    product:'Cocoa Beans',
                    quantity:1240,
                    percentage:82,
                    color:'#DC3545',
                },
                {
                    product:'Cocoa Butter',
                    quantity:365,
                    percentage:61,
                    color:'#FFA049',
                },
                {
                    product:'Cocoa Powder',
                    quantity:228,
                    percentage:48,
                    color:'#FCC34B',
                },
                {
                    product:'Chocolate Ingredients',
                    quantity:148,
                    percentage:36,
                    color:'#59C94F',
                },
                {
                    product:'Finished Chocolate Products',
                    quantity:62,
                    percentage:18,
                    color:'#1CBB8C',
                },
            ],
        
            riskSummary:[
                {
                    riskLevel:'Very High Risk',
                    percentage:8,
                    landEvaluated:900,
                },
                {
                    riskLevel:'High Risk',
                    percentage:26,
                    landEvaluated:3100,
                },
                {
                    riskLevel:'Medium Risk',
                    percentage:35,
                    landEvaluated:4200,
                },
                {
                    riskLevel:'Low Risk',
                    percentage:31,
                    landEvaluated:3700,
                },
            ]
        };
    }
}
